import auth from "@/shared/api/auth";
import { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { ProfileHeader } from "./ProfileHeader";
import { cn } from "@/lib/utils";
import tests from "@/shared/api/tests";
import { useAnonResults } from "@/hooks/useAnonResults";

export const Profile = () => {
  const [user, setUser] = useState(null);
  const pathname = useLocation().pathname;

  const { results, clearResults } = useAnonResults();

  const fetchUser = async () => {
    try {
      const res = await auth.profile();
      setUser(res.user);
      if (results.length > 0) {
        const saveRes = await tests.saveAnonResults(results, res.token);
        if (saveRes.status === 200) {
          clearResults();
        }
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    fetchUser();
  }, [results]);

  if (!user) return null;

  const checkActiveRoute = (path) => {
    console.log(pathname)
    return path === pathname
  }

  const tabStyle = (path) =>
    cn(
      "text-sm font-medium px-4 py-2 rounded-lg",
      checkActiveRoute(path) ? "bg-olive-800 text-white" : " text-foreground text-foreground bg-olive-100"
    )

  return (
    <div className="min-h-screen max-w-6xl w-full flex flex-col items-center justify-start mt-16 px-0 sm:px-4 py-4">
      <ProfileHeader user={user} />
      <div className="max-w-6xl w-full">

        <div className="flex my-8">
          <Link to="/profile" className={tabStyle("/profile")}>Расписание</Link>
          <Link to="/profile/tests" className={tabStyle("/profile/tests")}>Тесты</Link>
          {/* <Link to="/profile/results" className={tabStyle("/profile/results")}>Результаты тестирования</Link> */}
        </div>

        <Outlet />
      </div >
    </div>
  );
};
